export const DEFAULT_CURRENCY = {
    name: 'USD',
    rate: 1,
    // eslint-disable-next-line no-template-curly-in-string
    template: '${{amount}}',
};
